var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-upload",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconB-upload1",
    serifid: "iconB-upload"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M11.293,2.293c0.19,-0.19 0.444,-0.293 0.707,-0.293c0.263,0 0.517,0.103 0.707,0.293l5,5c0.39,0.39 0.39,1.024 0,1.414c-0.39,0.39 -1.024,0.39 -1.414,0l-3.293,-3.293l0,9.586c0,0.552 -0.448,1 -1,1c-0.552,0 -1,-0.448 -1,-1l0,-9.586l-3.293,3.293c-0.39,0.39 -1.024,0.39 -1.414,0c-0.39,-0.39 -0.39,-1.024 0,-1.414l5,-5Zm8.707,12.707c0,-0.552 0.448,-1 1,-1c0.552,-0 1,0.448 1,1l0,1.2c0,1.925 -0.061,2.881 -0.436,3.616c-0.383,0.753 -0.995,1.365 -1.748,1.748c-0.735,0.375 -1.691,0.436 -3.616,0.436l-8.4,-0c-1.925,-0 -2.881,-0.061 -3.616,-0.436c-0.753,-0.383 -1.365,-0.995 -1.748,-1.748c-0.375,-0.735 -0.436,-1.691 -0.436,-3.616l0,-1.2c0,-0.552 0.448,-1 1,-1c0.552,-0 1,0.448 1,1l0,1.2c0,1.436 -0.061,2.159 0.218,2.708c0.192,0.376 0.498,0.682 0.874,0.874c0.548,0.279 1.272,0.218 2.708,0.218l8.4,0c1.436,0 2.16,0.061 2.708,-0.218c0.376,-0.192 0.682,-0.498 0.874,-0.874c0.279,-0.548 0.218,-1.272 0.218,-2.708l0,-1.2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBUpload);
export default __webpack_public_path__ + "static/media/iconB-upload.2fbdd78f36a66b92d19c7a1e0ecbe936.svg";
export { ForwardRef as ReactComponent };